document.addEventListener("DOMContentLoaded", function () {
  var mql = window.matchMedia("(max-width: 767px)");
  var wrapper, scrollHandler;

  // 原有設定
  var fixedRight = document.querySelector(".fixed-right");
  if (fixedRight) fixedRight.style.display = "none";
  var fixedLeft = document.querySelector(".fixed-left");
  if (fixedLeft) fixedLeft.style.display = "none";
  var headerTopRightPlaceholder = document.getElementById(
    "header-top-right-placeholder"
  );
  var HeaderBottom = document.querySelector(".header-bottom");

  // Logo 原位
  var logoEl = document.querySelector(".header-top--left.header__logo");
  var logoOrigPar = logoEl.parentNode;
  var logoOrigNext = logoEl.nextSibling;

  // 語言切換原位
  var langEl = document.querySelector(".top-language-currency");
  var langOrigPar = langEl.parentNode;
  var langOrigNext = langEl.nextSibling;

  // 主選單容器
  var mainMenu = HeaderBottom.querySelector(".main-menu");

  // 綁定語言按鈕：在任何時候都可打開／關閉
  function bindLangToggle() {
    var btn = langEl.querySelector(".disclosure__button");
    var menu = langEl.querySelector(".dropdown-language");
    if (!btn || !menu) return;
    // 防重複綁
    if (btn._toggled) return;
    btn._toggled = true;

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      menu.classList.toggle("show");
    });
    // 點外面關掉
    document.addEventListener("click", function () {
      menu.classList.remove("show");
    });
  }

  function updateAtTopClass() {
    var scrollTop =
      window.pageYOffset || document.documentElement.scrollTop || 0;

    if (scrollTop <= 0) {
      // 頂部：還原
      wrapper && wrapper.classList.add("at-top");
      headerTopRightPlaceholder &&
        (headerTopRightPlaceholder.style.display = "");
      HeaderBottom &&
        HeaderBottom.style.setProperty(
          "background",
          "transparent",
          "important"
        );

      if (logoEl.parentNode !== logoOrigPar)
        logoOrigPar.insertBefore(logoEl, logoOrigNext);
      if (langEl.parentNode !== langOrigPar)
        langOrigPar.insertBefore(langEl, langOrigNext);

      HeaderBottom.style.display = "";
      HeaderBottom.style.flexDirection = "";
      HeaderBottom.style.alignItems = "";
      logoEl.style.marginRight = "";
      langEl.style.marginLeft = "";
    } else {
      // 非頂部：一列排列
      wrapper && wrapper.classList.remove("at-top");
      headerTopRightPlaceholder &&
        (headerTopRightPlaceholder.style.display = "none");
      HeaderBottom &&
        HeaderBottom.style.setProperty("background", "#fff", "important");

      // 搬動
      if (logoEl.parentNode !== HeaderBottom)
        HeaderBottom.insertBefore(logoEl, mainMenu);
      if (langEl.parentNode !== HeaderBottom) HeaderBottom.appendChild(langEl);

      // 樣式
      logoEl.style.marginRight = "30px";
      langEl.style.marginLeft = "auto";

      var w = window.innerWidth;
      // 寬度 <=982 時隱藏
      if (w <= 982) {
        HeaderBottom.style.display = "none";
        return;
      } else {
        HeaderBottom.style.display = "flex";
      }
      HeaderBottom.style.flexDirection = "row";
      HeaderBottom.style.alignItems = "center";

      // 綁定下拉
      bindLangToggle();
    }
  }

  function enableDesktop() {
    wrapper =
      document.querySelector("sticky-header.header-wrapper") ||
      document.querySelector(".header-wrapper");
    if (!wrapper) return console.error("找不到 .header-wrapper");
    updateAtTopClass();
    scrollHandler = updateAtTopClass;
    window.addEventListener("scroll", scrollHandler, { passive: true });
  }

  function disableDesktop() {
    if (scrollHandler)
      window.removeEventListener("scroll", scrollHandler, { passive: true });
    wrapper && wrapper.classList.remove("at-top");
    fixedRight && (fixedRight.style.display = "");
    headerTopRightPlaceholder && (headerTopRightPlaceholder.style.display = "");

    if (logoEl.parentNode !== logoOrigPar)
      logoOrigPar.insertBefore(logoEl, logoOrigNext);
    if (langEl.parentNode !== langOrigPar)
      langOrigPar.insertBefore(langEl, langOrigNext);

    HeaderBottom.style.display = "";
    HeaderBottom.style.flexDirection = "";
    HeaderBottom.style.alignItems = "";
    logoEl.style.marginRight = "";
    langEl.style.marginLeft = "";
  }

  function handleBreakpoint(e) {
    if (e.matches) disableDesktop();
    else enableDesktop();
  }

  handleBreakpoint(mql);
  if (mql.addEventListener) mql.addEventListener("change", handleBreakpoint);
  else mql.addListener(handleBreakpoint);
});
